import Narrative from './container';

export default Narrative;



// WEBPACK FOOTER //
// ./src/components/Narrative/index.js